module.exports = __webpack_public_path__ + "static/series_v-0b81fd97e9bad374d3349efabad2d1b3.png";